import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

export default function SmoothScroll() {
  const { pathname } = useLocation();

  useEffect(() => {
    const handleClick = (e: MouseEvent) => {
      const target = e.target as HTMLElement;
      const anchor = target.closest('a[href^="#"]');
      if (!anchor) return;

      const href = anchor.getAttribute('href');
      if (!href || href === '#') return;

      const id = href.slice(1);
      const element = document.getElementById(id);
      if (!element) return;

      e.preventDefault();

      // Update URL hash without triggering a jump
      window.history.replaceState(null, '', `${pathname}${href}`);

      element.scrollIntoView({ behavior: 'smooth', block: 'start' });
    };

    document.addEventListener('click', handleClick);
    return () => document.removeEventListener('click', handleClick);
  }, [pathname]);

  return null;
}